import { css } from "@vitality-ds/system";
export default css({
  padding: "$sm $md"
});